import CartMixin from './CartMixin'

export default {
    mixins: [
        CartMixin
    ]
}